/**
 * Fullwidth Tabs Component - Updated for new palette picker
 * Assumes moving pill and ghost pill elements already exist in template
 * Uses component__fullwidth_tabs-container class to match naming convention
 */
(function() {
  // Component implementation
  const FullwidthTabs = {
    init: function() {
      const $ = jQuery;
      
      // Find all fullwidth tab components on the page
      $('.component__fullwidth_tabs').each(function() {
        const $container = $(this).find('.tab-wrapper'); // Target the tab wrapper
        const containerId = $container.attr('id');
        
        // Initialize this specific tab container
        FullwidthTabs.initTabSet($container, containerId);
      });
    },
    
    initTabSet: function($container, containerId) {
      const $ = jQuery;
      
      // Select all relevant elements within this container
      const $tabsNav = $container.find('.tabs-nav-wrapper');
      const $tabButtons = $container.find('.tab-button');
      const $tabContents = $(`.tabs-block[data-tabs-parent="${containerId}"]`);
      const $movingPill = $container.find('.moving-pill');
      const $ghostPill = $container.find('.ghost-pill');
      
      // Find active tab on load
      let $activeTab = $tabButtons.filter('.active');
      
      // If no active tab is found, make the first tab active
      if (!$activeTab.length && $tabButtons.length) {
        $activeTab = $tabButtons.first();
        $activeTab.addClass('active pointer-events-none');
        
        const firstTabId = $activeTab.data('tab');
        if (firstTabId) {
          // Show the first Tabs Block
          $(`#${firstTabId}`).removeClass('hidden');
        }
      }
      
      // Initialize pill on first load
      if ($activeTab.length && $movingPill.length) {
        const $activeLabel = $activeTab.find('.tab-label');
        const bgColorData = FullwidthTabs.getBackgroundColor($activeTab);
        
        // Set the initial position and style for the moving pill
        updatePillPosition($movingPill, $activeLabel, $tabsNav);
        $movingPill.removeClass(function(index, css) {
          return (css.match(/(^|\s)bg-\S+/g) || []).join(' ');
        }).addClass(`bg-${bgColorData.pillColor}`);
        
        // Initialize ghost pill with the same position but hidden
        if ($ghostPill.length) {
          updatePillPosition($ghostPill, $activeLabel, $tabsNav);
          $ghostPill.css('opacity', 0);
        }
        
        // Make sure active tab label is highlighted
        $activeLabel.addClass('!text-blue-700');
      }
      
      // Handle tab hover effects
      $tabsNav.on('mouseenter', '.tab-button', function() {
        const $this = $(this);
        const $hoverLabel = $this.find('.tab-label');
        
        // Only show ghost pill if this isn't the active tab
        if (!$this.hasClass('active') && $ghostPill.length) {
          // Animate ghost pill to hovered tab position
          updatePillPosition($ghostPill, $hoverLabel, $tabsNav);
          $ghostPill.css('opacity', 0.6);
        } else {
          // If hovering the active tab, hide ghost pill
          $ghostPill.css('opacity', 0);
        }
      });
      
      // Hide ghost pill when leaving tab navigation area
      $tabsNav.on('mouseleave', function() {
        if ($ghostPill.length) {
          $ghostPill.css('opacity', 0);
        }
      });
      
      // Handle tab clicks
      $tabButtons.on('click', function() {
        const $this = $(this);
        const tabId = $this.data('tab');
        const bgColorData = FullwidthTabs.getBackgroundColor($this);
        const $clickedLabel = $this.find('.tab-label');
        
        // Update tabs
        $tabButtons.removeClass('active pointer-events-none');
        $tabButtons.find('.tab-label').removeClass('!text-blue-700');
        $this.addClass('active pointer-events-none');
        $clickedLabel.addClass('!text-blue-700');
        
        // Hide ghost pill when clicking
        if ($ghostPill.length) {
          $ghostPill.css('opacity', 0);
        }
        
        // Update moving pill - animate to new position
        if ($movingPill.length && $clickedLabel.length) {
          updatePillPosition($movingPill, $clickedLabel, $tabsNav);
          
          // Update pill background color
          $movingPill.removeClass(function(index, css) {
            return (css.match(/(^|\s)bg-\S+/g) || []).join(' ');
          }).addClass(`bg-${bgColorData.pillColor}`);
        }
        
        // Simple fade transition for content
        // First fade out all tabs
        $tabContents.css('opacity', 0);
        
        // Update the wrapper background color to match the new tab
        const $contentWrapper = $container.next('.tabs-block-wrapper');
        
        // Remove any existing background classes and add the new one
        $contentWrapper.removeClass(function(index, css) {
          return (css.match(/(^|\s)bg-\S+/g) || []).join(' ');
        }).addClass(`bg-${bgColorData.backgroundColor}`);
        
        // After a short delay, hide previous tabs and show new tab
        setTimeout(function() {
          $tabContents.addClass('hidden');
          const $newContent = $(`#${tabId}`);
          $newContent.removeClass('hidden');
          
          // Then fade in the new tab
          setTimeout(function() {
            $newContent.css('opacity', 1);
          }, 50);
        }, 200);
      });
      
      // Helper function to get background color information
      function getBackgroundColor($tab) {
        // Get the base color slug from data-bg-color
        const baseColor = $tab.data('bg-color') || 'cream';
        
        // Check if we have specific shade data attributes (new format)
        const bgColor100 = $tab.data('bg-color-100');
        
        if (bgColor100) {
          // New format: use specific shade data
          return {
            backgroundColor: bgColor100,      // 100 shade for content background
            pillColor: `${baseColor}-500`    // 500 shade for pill/indicator
          };
        } else {
          // Fallback: construct from base color
          return {
            backgroundColor: `${baseColor}-100`,
            pillColor: `${baseColor}-500`
          };
        }
      }
      
      // Helper function to update pill position
      function updatePillPosition($pill, $label, $nav) {
        $pill.css({
          width: $label.outerWidth(),
          height: $label.outerHeight(),
          top: $label.position().top,
          left: $label.offset().left - $nav.offset().left
        });
      }
      
      // Handle window resizing
      $(window).on('resize', function() {
        // Update pill position
        if ($movingPill.length) {
          const $currentActiveTab = $tabButtons.filter('.active');
          if ($currentActiveTab.length) {
            const $activeLabel = $currentActiveTab.find('.tab-label');
            
            // Update pill positions on resize
            updatePillPosition($movingPill, $activeLabel, $tabsNav);
            
            if ($ghostPill.length) {
              updatePillPosition($ghostPill, $activeLabel, $tabsNav);
              $ghostPill.css('opacity', 0);
            }
          }
        }
      });
    },
    
    // Helper method to get background color data
    getBackgroundColor: function($tab) {
      // Get the base color slug from data-bg-color
      const baseColor = $tab.data('bg-color') || 'cream';
      
      // Check if we have specific shade data attributes (new format)
      const bgColor100 = $tab.data('bg-color-100');
      
      if (bgColor100) {
        // New format: use specific shade data
        return {
          backgroundColor: bgColor100,      // 100 shade for content background
          pillColor: `${baseColor}-100`   
        };
      } else {
        // Fallback: construct from base color
        return {
          backgroundColor: `${baseColor}-100`,
          pillColor: `${baseColor}-100`
        };
      }
    }
  };

  // Initialize on document ready
  jQuery(document).ready(function() {
    FullwidthTabs.init();
  });
  
  // Make available globally if needed
  window.FullwidthTabs = FullwidthTabs;
})();